import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const doraComponent: ComponentDef = {
  id: 'dora',
  name: 'DoRA',
  description: 'Weight-Decomposed Low-Rank Adaptation: decomposes W into magnitude (scalar) × unit-direction (matrix), then adapts direction via LoRA while learning magnitude separately.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'rank', label: 'LoRA rank', type: 'number', default: 16, min: 1, max: 256, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const rank = Number(params.rank);

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    // ── Frozen pretrained weight decomposed as W = m · (W / ‖W‖_c) ──
    // m: column-wise magnitude vector (trainable scalar per output neuron)
    // V = W / ‖W‖_c : unit-direction matrix (frozen at init)
    g.linear('W_frozen', 'x', [d_model, d_model]);           // frozen W·x
    g.activation('W_norm', 'W_frozen', '‖W‖_c  (column norms)'); // column norms
    g.scale('V', 'W_frozen', '÷ ‖W‖_c  (unit direction)');   // V = W/‖W‖_c

    // ── LoRA direction update: A·B adapts the direction ──
    g.linear('lora_A', 'x', [d_model, rank]);
    g.linear('lora_B', 'lora_A', [rank, d_model]);
    g.scale('lora_scaled', 'lora_B', 'α/r');

    // ── Updated direction: V + ΔW (LoRA delta) ──
    g.add('V_adapted', 'V', 'lora_scaled');

    // ── Re-normalise to unit direction ──
    g.activation('V_adapted_norm', 'V_adapted', '‖V + ΔW‖_c');
    g.scale('direction', 'V_adapted', '÷ ‖V + ΔW‖_c');

    // ── Trainable magnitude m scales each output column ──
    g.activation('magnitude', 'W_norm', 'm  (trainable, init = ‖W‖_c)');
    g.mul('dora_out', 'magnitude', 'direction');

    g.output('out', 'dora_out');
    return g.build();
  }
};
